<user-change-password-mobile *ngIf="isMobile"></user-change-password-mobile>
<user-change-password-desktop *ngIf="!isMobile"></user-change-password-desktop>